import { Injectable } from '@angular/core';
import { IConfig } from '../interfaces/config.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigDataService {
  private configSubject = new BehaviorSubject<IConfig | undefined>(undefined);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  loading$ = this.loadingSubject.asObservable();
  config$ = this.configSubject.asObservable();

  setConfig(config: IConfig | undefined): void {
    this.configSubject.next(config);
  }

  setLoading(isLoading: boolean): void {
    this.loadingSubject.next(isLoading);
  }

  getCurrentConfig() {
    return this.configSubject.value;
  }

  getCurrentLoading() {
    return this.loadingSubject.value;
  }

  reset(): void {
    this.configSubject.next(undefined);
    this.loadingSubject.next(false);
  }
}
